// extracted by mini-css-extract-plugin
export default {"item":"item___2dqef","content":"content___109xx"};